// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5f-1";
export var standaloneTable = "_5f-0";